var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.awaitData)?_c('apparatus',{attrs:{"battalionData":_vm.battalionData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }